// src/i18n/index.ts
import { createI18n } from "vue-i18n";
import ko from "./ko.json";
import en from "./en.json";

import siteKo from "./site/ko.json";
import siteEn from "./site/en.json";

const getBrowserLocale = (): string => {
  const lang = navigator.language || navigator.languages[0];
  if (lang.startsWith("ko")) return "ko";
  if (lang.startsWith("en")) return "en";
  return "en"; // fallback
};
sessionStorage.setItem("lang", sessionStorage.getItem("lang") || getBrowserLocale());
const i18n = createI18n({
  legacy: false,
  locale: sessionStorage.getItem("lang") || "ko",
  fallbackLocale: "ko",
  messages: { ko: { ...ko, ...siteKo }, en: { ...en, ...siteEn } },
});

export default i18n;
